import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const includes = [{
  label: '📘 Resin Architect™ — 6 premium volumes',
  value: 'Value: $97'
}, {
  label: '🎁 5 exclusive bonuses',
  value: 'Value: $147'
}];
const guarantees = ['One-time payment', 'Lifetime access', 'No monthly fees', 'Instant download'];
export function Offer() {
  return <section id="offer" className="w-full bg-cream px-5 py-16 sm:px-8 md:py-20" data-id="element-176" data-mp="u0ocustkp26s">
      <div className="mx-auto max-w-2xl" data-id="element-177" data-mp="p1l530m7khv4">
        <div className="text-center" data-id="element-178" data-mp="13wrbhop7uioz">
          <p className="text-[12px] font-extrabold uppercase tracking-[0.16em] text-gold-deep" data-id="element-179" data-mp="13xstkd4ng5g7">
            🏆 Special launch offer
          </p>
          <h2 className="mt-3 font-display text-[28px] font-bold leading-tight text-ink sm:text-4xl" data-id="element-180" data-mp="2fc698up91el5">
            Everything you receive today
          </h2>
        </div>

        <div className="mt-8 rounded-3xl border border-ink/10 bg-white p-5 shadow-card sm:p-8" data-id="element-181" data-mp="2actku5iqbzgg">
          <ul className="space-y-4" data-id="element-182" data-mp="pjz47x579lzu">
            {includes.map(item => <li key={item.label} className="flex flex-col gap-1 border-b border-ink/10 pb-4 sm:flex-row sm:items-center sm:justify-between" data-id="element-183" data-mp="ui0i83nrqv4g">
                <span className="text-[15px] font-semibold leading-snug text-ink" data-id="element-184" data-mp="13iynsqduvap5">
                  {item.label}
                </span>
                <span className="text-[13px] font-bold uppercase tracking-[0.08em] text-clay" data-id="element-185" data-mp="6rms4ioqv6ci">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="mt-5 flex items-center justify-between" data-id="element-186" data-mp="fsb477ukuwmr">
            <span className="text-[12px] font-extrabold uppercase tracking-[0.14em] text-ink/60" data-id="element-187" data-mp="klxkrb3v3knu">
              Total value
            </span>
            <span className="font-display text-2xl font-bold text-clay line-through" data-id="element-188" data-mp="3k6t2i28d6p5n">$244</span>
          </div>

          <div className="mt-7 rounded-2xl bg-ink px-5 py-7 text-center" data-id="element-189" data-mp="vfqtjs3t4ung">
            <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-cream/70" data-id="element-190" data-mp="vdnuyjol9t74">
              Today you get complete access for just
            </p>
            <p className="mt-2 font-display text-[64px] font-bold leading-none text-gold-light sm:text-[80px]" data-id="element-191" data-mp="1548ss4wfutoz">
              $27
            </p>
            <ul className="mt-5 grid grid-cols-2 gap-2 text-left" data-id="element-192" data-mp="108tjzrdafnzf">
              {guarantees.map(item => <li key={item} className="flex items-center gap-1.5 text-[12px] font-semibold text-cream/85" data-id="element-193" data-mp="7i1o6v04x1cm">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-gold-light" aria-hidden="true" data-id="element-194" data-mp="liw0hoqazmgk" />
                  {item}
                </li>)}
            </ul>
          </div>

          <p className="mt-6 text-center text-[14px] leading-relaxed text-clay" data-id="element-195" data-mp="1wv58dd9vvcfy">
            For less than $30 you get a professional visual reference and planning system you can
            return to every time you organize an anterior composite case.
          </p>

          <CtaButton className="mt-6" label="Get Resin Architect™ for $27" microcopy="One-time payment of $27 · Instant access · Lifetime access · 7-day guarantee" currencyNote data-id="element-196" data-mp="25e0c9j435u0y" />

          <Countdown className="mt-8" data-id="element-197" data-mp="1vft0deonm25t" />

          <ScarcityBar className="mt-8" data-id="element-198" data-mp="2j5ev9pxztv80" />
        </div>
      </div>
    </section>;
}